var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.img}}),_c('p',[_vm._v("未找到指定页面")]),_c('el-button',{staticClass:"back",on:{"click":_vm.back}},[_vm._v("返回页面")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }